import { cn } from "@/utils";
import type { CanvasToolbarOrientation } from "./CanvasToolbarShell";
import { canvasToolbarDividerVariants } from "./canvasToolbarStyles";

interface CanvasToolbarDividerProps {
  orientation?: CanvasToolbarOrientation;
  className?: string;
}

export function CanvasToolbarDivider({
  orientation = "horizontal",
  className,
}: CanvasToolbarDividerProps) {
  return (
    <div
      className={cn(canvasToolbarDividerVariants({ orientation }), className)}
      aria-hidden="true"
    />
  );
}
